import { render } from "./detailsView.vue?vue&type=template&id=efb1c8ae"
import script from "./detailsView.vue?vue&type=script&lang=js"
export * from "./detailsView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__